import { AutoTradingControls } from "@/components/AutoTradingControls";
import { EntryPolicyControls } from "@/components/EntryPolicyControls";
import { ExecutionLedger, PositionActionLedger, VirtualLotsLedger } from "@/components/ExecutionLedger";
import { LiveTradingControls } from "@/components/LiveTradingControls";
import { OkxCredentialPanel } from "@/components/OkxCredentialPanel";
import { WaitingEntryLedger } from "@/components/WaitingEntryLedger";

export const TradingAccountWorkspace = ({ environment, data, busy, handlers }) => {
  const live = environment === "LIVE";
  const prefix = live ? "live" : "demo";
  const riskPolicyId = live ? "live-fixed-risk-policy" : "fixed-risk-policy";
  const riskValueId = live ? "live-fixed-risk-value" : "fixed-risk-value";
  return <div className={`trading-workspace ${live ? "live-workspace" : ""}`}
    data-testid={`${prefix}-trading-workspace`}>
    <OkxCredentialPanel data={data} busy={busy} environment={environment}
      onSave={handlers.saveCredentials} onRetest={handlers.checkConnection}
      onDelete={handlers.deleteCredentials} />
    {live ? <LiveTradingControls data={data} busy={busy}
      onCheck={handlers.checkConnection} onEnable={handlers.enableLive}
      onDisarm={handlers.disarmLive} onEmergencyStop={handlers.emergencyStopLive} /> : <>
      <AutoTradingControls data={data} busy={busy}
        onConnectionCheck={handlers.checkConnection} onMasterChange={handlers.changeMaster} />
      <EntryPolicyControls value={data.reference_entry_adverse_tolerance_percent}
        busy={busy} onSave={handlers.saveEntryTolerance} />
    </>}
    <div className="risk-policy" data-testid={riskPolicyId}>
      <div><span>Environment</span><b data-testid={`${prefix}-environment-value`}>{environment}</b></div>
      <div><span>单笔固定风险</span><b data-testid={riskValueId}>
        {data.fixed_risk_per_trade || (live ? "50" : "100")} USDT</b></div>
      <div><span>最大允许杠杆</span><b data-testid={live ? "live-max-leverage-value" : "max-leverage-value"}>
        {data.max_leverage || "30"}x</b></div>
      <div><span>账户 Equity</span><b data-testid={`${prefix}-equity-value`}>
        {data.usdt_equity || "—"} USDT</b></div>
    </div>
    <p className="policy-note" data-testid={live ? "live-fixed-risk-policy-note" : "fixed-risk-policy-note"}>
      {live ? "风险金额固定为 50 USDT；Equity 与最大 30x 杠杆不会放大初始止损风险。"
        : "风险金额固定为 100 USDT；账户余额与最大 30x 杠杆不会放大初始止损风险。"}
    </p>
    <WaitingEntryLedger rows={data.waiting_entries || []} />
    <ExecutionLedger rows={data.executions || []} />
    <PositionActionLedger rows={data.actions || []} />
    <VirtualLotsLedger rows={data.virtual_lots || []} />
  </div>;
};